import { Viewer } from 'photo-sphere-viewer';

const panoramaViewerInit = () => {
    const panoramaViewers = document.querySelectorAll('.c-panorama-viewer');

    if (panoramaViewers.length > 0) {
        panoramaViewers.forEach(panoramaViewer => {
            const container = panoramaViewer.querySelector('.panorama-container');
            const { imageUrl } = panoramaViewer.dataset;
            if (imageUrl) {
                const initViewer = () => {
                    const viewer = new Viewer({
                        container,
                        panorama: imageUrl,
                        navbar: ['zoom', 'fullscreen'],
                        minFov: 60,
                        maxFov: 90,
                        defaultZoomLvl: 50
                    });

                    const iconDiv = document.createElement('div');
                    const svgIcon = document.createElementNS(
                        'http://www.w3.org/2000/svg',
                        'svg'
                    );
                    const svgUse = document.createElementNS(
                        'http://www.w3.org/2000/svg',
                        'use'
                    );
                    svgUse.setAttributeNS(
                        'http://www.w3.org/1999/xlink',
                        'href',
                        '#360'
                    );
                    iconDiv.classList.add('panorama-icon');
                    svgIcon.classList.add('svg-icon');
                    svgIcon.appendChild(svgUse);
                    iconDiv.appendChild(svgIcon);
                    panoramaViewer.appendChild(iconDiv);

                    viewer.on('ready', () => {
                        const icon = panoramaViewer.querySelector('.panorama-icon');
                        icon.classList.add('show-icon');
                    });

                    return { viewer, iconDiv };
                };

                const modal = panoramaViewer.closest('.c-modal');
                if (modal) {
                    let viewer;
                    let icon;
                    const observer = new MutationObserver(() => {
                        if (window.getComputedStyle(modal).display !== 'none') {
                            const { viewer: viewerEl, iconDiv } = initViewer();
                            viewer = viewerEl;
                            icon = iconDiv;
                        } else if (viewer.destroy) {
                            viewer.destroy();
                            icon.remove();
                        }
                    });
                    observer.observe(modal, { attributes: true });
                } else {
                    initViewer();
                }
            }
        });
    }
};

document.addEventListener('DOMContentLoaded', panoramaViewerInit);
